<template>
    <UiPartners :blok="blok" />
</template>

<script setup lang="ts">
import type { IPartners } from '@nuxt-monorepo/ui/types/components/Partners';

defineProps<{ blok: IPartners }>();
</script>

<style lang="postcss" scoped></style>
